import {
  Component,
  OnInit,
  Input,
  ViewChild,
  HostListener,
} from '@angular/core';
import moment from 'moment';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput, Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import resourceDayGridPlugin from '@fullcalendar/resource-daygrid';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { TechnicianService } from '../../../../../services/technician.service';
import { AppConfig } from '../../../../../app.config';
import { MessageService } from 'primeng/api';
import { AddEditStaffLeaveComponent } from './add-edit-staff-leave/add-edit-staff-leave.component';

@Component({
  selector: 'app-staff-leave',
  templateUrl: './staff-leave.component.html',
  styleUrls: ['./staff-leave.component.scss'],
})
export class StaffLeaveComponent implements OnInit {
  @Input() users;
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  public nowTime: any = new Date();
  public calendarButtonText = {
    today: 'today',
    month: 'month',
    week: 'week',
    day: 'day',
  };
  headerView = 'listWeek, listMonth';
  calendarPlugins = [
    resourceDayGridPlugin,
    resourceTimeGridPlugin,
    resourceTimelinePlugin,
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
    listPlugin,
  ];
  public technicians: any = [];
  public techniciansAccounts: any = [];
  public events: any = [];
  public calendarApi: Calendar;
  public contentHeight: number = 800;
  public calendarWeekends = true;
  public workingHoursMinTime = '00:00:00';
  public minTime = '00:00:00';
  public maxTime = '24:00:00';

  constructor(
    private technicianService: TechnicianService,
    private appConfig: AppConfig,
    private translate: TranslateService,
    public modalService: NgbModal,
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.contentHeight = window.innerHeight - 320;
  }

  ngOnInit() {
    this.filterUsers();

    this.calendarButtonText = {
      today: this.translate.instant('bikeshop.calendar.today'),
      month: this.translate.instant('bikeshop.calendar.month'),
      week: this.translate.instant('bikeshop.calendar.week'),
      day: this.translate.instant('bikeshop.calendar.day'),
    };
  }

  ngAfterViewInit() {
    this.calendarApi = this.calendarComponent.getApi();    
    this.addCalendarEventSource();
    this.contentHeight = window.innerHeight - 320;
    this.calendarApi.setOption('locale', this.appConfig.getLocale());
  }

  filterUsers() {
    this.techniciansAccounts = this.users.filter((x) => {
      return x.TechnicianID !== 0;
    });

    this.technicians = this.techniciansAccounts.map((technician) => {
      return {
        id: technician.TechnicianID,
        title: technician.Name + ' ' + technician.Surname,
        businessHours: [
          {
            startTime: '00:00',
            endTime: '23:59',
            daysOfWeek: [1, 2, 3, 4, 5, 6, 0],
          },
        ],
        Name: technician.Name + ' ' + technician.Surname,
      };
    });
  }

  addCalendarEventSource() {
    this.events = [];
    this.calendarApi.removeAllEvents();
    this.techniciansAccounts.forEach((technician) => {
      this.technicianService
        .getTechnicianEvents(
          technician.TechnicianID,
          moment().add(-1, 'year').format('YYYY-MM-DD'),
          moment().add(1, 'year').format('YYYY-MM-DD'),
        )
        .subscribe((technicianEvents) => {
          this.events = [...this.events, ...technicianEvents];
          technicianEvents.forEach((technicianEvent) => {
            var startTime = technicianEvent.StartTime + 'Z'; //This is a bit of a jippo to force the calendar to use this date as UTC
            let startDate = new Date(startTime);
            let endDate = new Date(startTime);
            endDate.setMinutes(endDate.getMinutes() + technicianEvent.Duration);
            this.calendarApi.addEvent({
              id: technicianEvent.ID,
              resourceId: technicianEvent.TechnicianID,
              start: startDate,
              end: endDate,
              title:
                technician.Name +
                ' ' +
                technician.Surname +
                ' - ' +
                technicianEvent.Description,
              editable: false,
              selectable: false,
              durationEditable: false,
              color:
                '#' +
                this.intToRGB(
                  this.hashCode(technician.Name + ' ' + technician.Surname),
                ),
              //backgroundColor: 'transparent',
              //borderColor:'transparent'
            });
          });
        });
    });
  }

  addLeave() {
    const modalRef = this.modalService.open(AddEditStaffLeaveComponent, {
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.technicians = this.techniciansAccounts;
    modalRef.componentInstance.event = {};

    modalRef.result.then(
      (result) => {
        this.addCalendarEventSource();
      },
      (onrejected) => {
        this.addCalendarEventSource();
      },
    );
  }

  hashCode(str) {
    var hash = 0;
    if (str) {
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
    }
    return hash;
  }

  intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return '00000'.substring(0, 6 - c.length) + c;
  }

  renderEvent(info) {}

  getNowDate() {
    return moment(this.nowTime).format('YYYY-MM-DDTHH:mm:ss');
  }

  dateClicked(event: any) {}

  scheduleClicked(event: any) {
    var event = this.events
      .filter((x) => {
        return x.ID.toString() === event.event.id.toString();
      })
      .pop();

    if (event) {
      const modalRef = this.modalService.open(AddEditStaffLeaveComponent, {
        backdrop: 'static',
        windowClass: 'user-modal',
      });
      modalRef.componentInstance.technicians = this.techniciansAccounts;
      modalRef.componentInstance.event = event;

      modalRef.result.then(
        (result) => {
          this.addCalendarEventSource();
        },
        (onrejected) => {
          this.addCalendarEventSource();
        },
      );
    }
  }

  scheduleMoved(event: any) {}

  scheduleDurationChanged(event: any) {}
}
